import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Meil on valikus üle 100 000 toote ning häid soodustusi jagub igasse päeva. Vaata kohe järele!

  <span style="color:#85c1dc;">**FI:**</span>
  Verkkoselain ei muista vieraan ostoskoria, mutta ostoskorin sisältö on aina saatavilla ON24-asiakkaan tilillä.

  <span style="color:#85c1dc;">**RU:**</span>
  Веб-браузер не запоминает корзину покупок гостя, но содержимое корзины всегда доступно в аккаунте постоянного клиента.
*/
/* @__NO_SIDE_EFFECTS__ */
const m1183 = msg(
  mf`Meil on valikus üle 100 000 toote ning häid soodustusi jagub igasse päeva. Vaata kohe järele!`,
  mf`Verkkoselain ei muista vieraan ostoskoria, mutta ostoskorin sisältö on aina saatavilla ON24-asiakkaan tilillä.`,
  mf`Веб-браузер не запоминает корзину покупок гостя, но содержимое корзины всегда доступно в аккаунте постоянного клиента.`,
)

export { m1183 as 'w.basket.empty.second.text' }